const filestackUploadPolicyData = document.getElementById('__FILESTACK_UPLOAD_POLICY_DATA__')?.textContent || '{}';

const filestackUploadPolicy = JSON.parse(filestackUploadPolicyData);

export default filestackUploadPolicy;